import { Text } from "@clipboard-health/ui-components";
import { DEBUG_BASE_PATH } from "@src/appV2/Debug/paths";
import {
  DeploymentEnvironmentName,
  environmentConfig,
  isDevelopmentNodeEnvironment,
} from "@src/appV2/environment";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { isCapacitorPlatform } from "@src/appV2/lib";
import { ACCOUNT_UPDATES_FULL_PATH } from "@src/appV2/redesign/Accounts/paths";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { AccountListItem } from "../components/AccountListItem";
import { logAccountPageMenuItemTapped } from "../utils";

export function AccountsPageTestingSection() {
  const history = useHistory();
  const worker = useDefinedWorker();

  const showDebugPageMenuItemForTesting =
    useCbhFlag(CbhFeatureFlag.SHOW_DEBUG_PAGE_MENU_ITEM_IN_MY_ACCOUNT, { defaultValue: false }) ||
    isDevelopmentNodeEnvironment();

  const showAppUpdatePageMenuItemForTesting =
    isCapacitorPlatform() &&
    (Boolean(worker.isTestAccount) ||
      environmentConfig.REACT_APP_ENVIRONMENT_NAME !== DeploymentEnvironmentName.PRODUCTION);

  const hasMenuItems = showDebugPageMenuItemForTesting || showAppUpdatePageMenuItemForTesting;

  if (!hasMenuItems) {
    return null;
  }

  return (
    <>
      {showAppUpdatePageMenuItemForTesting && (
        <AccountListItem
          primaryText="App Updates"
          secondaryText={
            <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
              Check for and install updates
            </Text>
          }
          iconType="download"
          onClick={() => {
            logAccountPageMenuItemTapped("App Updates");
            history.push(ACCOUNT_UPDATES_FULL_PATH);
          }}
        />
      )}

      {showDebugPageMenuItemForTesting && (
        <AccountListItem
          primaryText="Debug"
          secondaryText={
            <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
              Internal testing
            </Text>
          }
          iconType="info"
          onClick={() => {
            logAccountPageMenuItemTapped("Debug");
            history.push(DEBUG_BASE_PATH);
          }}
        />
      )}
    </>
  );
}
